import React, { useState } from "react";
import { Button, Modal, Table, TableBody, TableHead, TableHeadCell } from "flowbite-react";
import "./AskToTrade.css";
import { getExchangeElementsTravToMakeRequest } from "../../../services/callAPI/toTravelerTrocs";
import UnvalidToast from "../../toasts/UnvalidToast";
import ValidToast from "../../toasts/ValidToast";
import { makeTrocRequest } from "../../../services/callAPI/trocsRequests";
import { AxiosError } from "axios";
import { exchangeElementsOfTrav } from "../../../pages/myExchangeElements/MyExchangeElements";
import { ISearchTrocResidentExtended } from "../../../services/interfaces/ITrocResident2";

interface IAskToTradeProps {
  pseudo: string;
  resTrocId: number;
  settriggerUseEffect: React.Dispatch<React.SetStateAction<boolean>>;
  setRTrocsList?: React.Dispatch<React.SetStateAction<ISearchTrocResidentExtended[]>>;
  setExpandedRowIndex: React.Dispatch<React.SetStateAction<number | null>>;
}

export function AskToTrade(props: IAskToTradeProps) {
  //destructuring
  const { pseudo, resTrocId, setRTrocsList, settriggerUseEffect, setExpandedRowIndex } = props;

  /* states */
  const [unValidToast, setUnvalidToast] = useState<boolean>(false);
  const [unValidToastMsg, setUnvalidToastMsg] = useState<string>();

  const [validToast, setValidToast] = useState<boolean>(false);

  const [openModal, setOpenModal] = useState<boolean>(false);

  const [exhangeElementsList, setExhangeElementsList] = useState<exchangeElementsOfTrav[]>();

  /* functions */
  async function getAndProcessExchangeElements() {
    try {
      const exhangeElements = await getExchangeElementsTravToMakeRequest();

      if (exhangeElements.length > 0) {
        setExhangeElementsList(exhangeElements);
        setOpenModal(true);
      }
      else {
        setUnvalidToastMsg("Tu n'as aucun élément à échanger !");
        setUnvalidToast(true);
      }
    } catch (error) {
      //afficher un toast adéquate
      setUnvalidToastMsg("Eléments non récupéré ! Rééssaye plus tard.")
      setUnvalidToast(true);
    }
  }

  async function handleMakeTrocRequest(travTrocId: number, resTrocId: number) {
    try {
      const response = await makeTrocRequest(travTrocId, resTrocId);

      if (response === 200) {
        setValidToast(true);

        //settriggerUseEffect(prev => !prev);
        if (setRTrocsList) {
          let rTrocsListUpdated = [];
          setRTrocsList((prev) => {
            rTrocsListUpdated = prev.filter((rTroc) => rTroc.id != resTrocId);
            return rTrocsListUpdated.length > 0 ? rTrocsListUpdated : [];
          });
          setExpandedRowIndex(null);
          return rTrocsListUpdated.length <= 0 ? settriggerUseEffect(prev => !prev) : null;
        }
      } else {
        throw new Error(`la réponse n'est pas celle attendue`);
      }
    } catch (error) {
      setOpenModal(false);

      if (error instanceof AxiosError) {
        if (error.response?.data.message === "Échec du traitement de l'abonnement : L'abonnement de l'utilisateur est invalide ou expiré.") {
          setUnvalidToastMsg("Impossible ! Votre abonnement a expiré.");
          setUnvalidToast(true);
        }
        else {
          setUnvalidToastMsg(undefined);
          setUnvalidToast(true);
        }
      }
      else if (error instanceof Error) {
        setUnvalidToastMsg(error.message);
        setUnvalidToast(true);
      }
      else {
        setUnvalidToastMsg(undefined);
        setUnvalidToast(true);
      }
    }
  }

  return (
    <>
      {unValidToast && <UnvalidToast message={unValidToastMsg ? unValidToastMsg : undefined} onClose={() => setUnvalidToast(false)} />}
      {validToast && <ValidToast message="Le résident a reçu votre demande" onClose={() => setValidToast(false)} />}

      <button className=" bg-greenCustom p-2 rounded-lg font-semibold text-white hover:bg-orangeCustom" onClick={() => getAndProcessExchangeElements()}>Demander à Trocker</button>

      {/* modal */}
      <Modal show={openModal} className="bg-transparent backdrop-blur-sm" size="2xl" onClose={() => setOpenModal(false)} popup>
        <Modal.Header className="pb-0 rounded-t-xl" />
        <Modal.Body className="flex flex-col items-center gap-2 overflow-x-hidden max-h-[90vh] p-4">

          <h3 className="mb-5 text-lg font-normal text-greenCustom dark:text-greenCustom">
            Choisis un élément à trocker avec {pseudo} ?
          </h3>

          <div className="bg-white overflow-y-auto rounded">
            <Table className="table-auto w-full border-collapse">
              <TableHead className="sticky top-0">
                <TableHeadCell id="TableHeadCell-my-elements" className="bg-orangeCustom text-center text-white">Mes elements</TableHeadCell>
              </TableHead>

              <TableHead className="sticky top-0">
                <TableHeadCell className="tableHeadCell-2 bg-orangeCustom px-4 py-2 min-w-[255px] text-white text-center">Mes services</TableHeadCell>
                <TableHeadCell className="tableHeadCell-2 bg-orangeCustom px-4 py-2 min-w-[255px] text-white text-center">Mes besoins</TableHeadCell>
                <TableHeadCell className="tableHeadCell-2 bg-orangeCustom max-w-10 text-white text-center">Action</TableHeadCell>
              </TableHead>

              <TableBody className="max-h-72 divide-y text-sm">
                {
                  exhangeElementsList && exhangeElementsList.length > 0 ? (
                    exhangeElementsList.map((item, index) => (
                      <React.Fragment key={index} >

                        <tr key={item.id} className="element border even:bg-gray-200">
                          {/* services part */}
                          <td id="services" className="">

                            <p className="text-center p-services">Mes services</p>

                            <div className="flex justify-center items-center gap-1 p-2">
                              {
                                item.matchedServices.map((service, index) => (
                                  <img key={index} className="h-20 w-20" src={`/servicesDuNomade-besoinsDuRésident/${service}.png`} alt="service" />
                                ))
                              }
                            </div>
                          </td>

                          {/* needs part */}
                          <td id="needs" className="">

                            <p className="text-center p-needs">Mes besoins</p>

                            <div className="flex justify-center items-center gap-1 p-2">
                              {
                                item.matchedNeeds.map((need, index) => (
                                  <img key={index} className="h-20 w-20" src={`/besoinsDuNomade-servicesDuRésident/${need}.png`} alt="besoin" />
                                ))
                              }
                            </div>
                          </td>

                          {/* select btn part */}
                          <td className="text-center">
                            <button className="bg-greenCustom px-2 py-1 rounded-full text-center text-white"
                              onClick={() => {
                                setOpenModal(false);
                                handleMakeTrocRequest(item.id, resTrocId);
                              }}
                            >
                              Sélectionner
                            </button>
                          </td>
                        </tr>

                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">Aucun élément à afficher.</td>
                    </tr>)
                }
              </TableBody>
            </Table>
          </div>

          <div className="w-full flex justify-center gap-4">
            <Button className="bg-lightRedCustom text-white py-0" onClick={() => setOpenModal(false)}>
              Fermer
            </Button>
          </div>

        </Modal.Body>

      </Modal>
    </>
  )
}